import { API } from '@/api';
import axios from 'axios';

const state = {
};
const getters = {
};
const actions = {
  async getIngresosList({ commit, State }, {adm, cond, options}) {
    const sortBy = options.sortBy[0] ? options.sortBy[0] + ',' + (options.sortDesc[0] ? 'desc' : 'asc') : '';
    const queryString = {page: options.page - 1, size: options.itemsPerPage, sort: sortBy};
    console.debug('queryString: %o', queryString);
    const response = await API.get('/ingresos/list/' + adm.id + '/' + cond.id, {params: queryString});
    console.debug('Ingresos: %o', response.data);
    return response.data;
  },
  async getIngresoById({ commit, State }, {adm, cond, ingreso}) {
    const response = await API.get('/ingresos/get/' + adm.id + '/' + cond.id + '/' + ingreso);
    return response.data;
  },
  // async getSaldoFavor({ commit, State }, {adm, cond, unid}) {
  //   console.log('admin: ', adm);
  //   const response = await API.get(`/ingresos/get/saldo/favor/${adm.id}/${cond.id}/${unid.id}`);
  //   return response;
  // },
  async addIngreso({ commit, State }, {admin, condo, ingreso}) {
    const response = await API.post('/ingresos/add/' + admin.id + '/' + condo.id, ingreso);
    return response.data;
  },
  async getAddUnidadIncome({ commit, State }, {admin, condo, unidad, ingreso}) {
    const response = await API.post(`/ingresos/add/unidad/${admin.id}/${condo.id}/${unidad.id}/${ingreso.id}`);
    return response.data;
  },
  /* async pagarRecibo({ commit, State }, {datos}) {
    const response = await API.post('/ingresos/pay/' + datos.recibo[0].id + '/' + datos.ingreso.id + '/' + datos.monto);
    return response.data;
  },   */



  async addCobroItemSaldo({ commit, State }, {datos}) {
    // console.log('addCobroItemSaldo Antes');
    // const response = await API.post('/ingresos/pay/recibo/' + datos.admin.id + '/' + datos.condo.id);

    const response = await API.post(`/ingresos/pay/recibo/${datos.admin.id}/${datos.condo.id}/${datos.recibo.id}`,
    // const response = await API.post(`/${datos.admin.id}/${datos.condo.id}/cobro/simple/items/${datos.recibo.id}`,

                    datos.cobro);
    // console.log('addCobroItemSaldo Despues');
    return response.data;
  },
  async matchCSV({ commit, State }, {datos}) {
    const headers = {
      'Content-Type': 'multipart/form-data',
    };
    const formData = new FormData();
    formData.append('title', datos.req.titulo);
    formData.append('file', datos.req.archivoCSV);
    formData.append('descripcion', datos.req.descripcion);
    formData.append('type', datos.req.tipoDeComprobante);
    formData.append('fechaEmision', datos.req.fechaDeEmision);
    formData.append('serie', datos.req.serie);
    formData.append('periodo', datos.req.periodo);
    const response = await API.post('/ingresos/matchcsv/' + datos.adm.id + '/' + datos.cond.id, formData, {headers});
    return response.data;
  },
};
const mutations = {
};

export default {
  actions,
  mutations,
  getters,
  state,
};
